import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { inject } from 'mobx-react';
import TabRoute from './tabRoute';
import AutoLogin from '../account/autoLogin';

@inject('oidcStore')
class PrivateRoute extends Component {
    
    render(){

        const isUserOnline = this.props.oidcStore.currentUser != null;

        return (<Route exact path={this.props.path} render={props => {
                    
                    if(isUserOnline) {
                        
                        return <TabRoute 
                                    component={this.props.component}
                                    routeId={this.props.routeId}
                                    {...props}
                                />
                    }
                    
                    return <AutoLogin />
                }}/>

        )
    }
}

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/components/router/privateRoute.jsx